import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import MaterialCategoryTableFilters from "components/subComponents/MaterialCategoryTableFilters";

import useMaterialCategoryList from "hooks/list/useMaterialCategoryList";

function ElencoCatMateriali() {
    const materialCategoryListHook = useMaterialCategoryList();

    const { navigateToNewMaterialCategory, alertConfirmHook, dataTableHook } =
        materialCategoryListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <MaterialCategoryTableFilters
                    materialCategoryListHook={materialCategoryListHook}
                />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewMaterialCategory}>
                        Nuova Categoria
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoCatMateriali;
